export const LOGIN = 'LOGIN'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const FETCH_COURSE_DATA = 'FETCH_COURSE_DATA';
export const SEND_PAYMENT_DATA = 'SEND_PAYMENT_DATA';
export const GET_LEARNER_DATA = 'GET_LEARNER_DATA';
export const SIGNUP = 'SIGNUP'
export const SIGNUP_FAILED = 'SIGNUP_FAILED'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const LOGIN_START = 'LOGIN_START'

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST'
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS"
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE"

export const GET_ALL_COURSES = 'GET_ALL_COURSES'
export const GET_INSTRUCTOR = 'GET_INSTRUCTOR';
export const GET_ALL_COURSE_DETAIL = 'GET_ALL_COURSE_DETAIL';
export const ADD_TO_CART = 'ADD_TO_CART';

export const FETCH_COURSE_REQUEST = 'FETCH_COURSE_REQUEST'
export const FETCH_COURSE_SUCCESSFUL = "FETCH_COURSE_SUCCESFUL"
export const FETCH_COURSE_FAILURE = "FETCH_COURSE_FAILURE"
export const POST_OTP = 'POST_OTP';

export const GET_CART_BY_COURSE_ID = 'GET_CART_BY_COURSE_ID'
export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS'
export const FETCH_COURSES_FAILURE = 'FETCH_COURSES_FAILURE'

export const FETCH_ORDER_REQUEST = "FETCH_ORDER_REQUEST"
export const FETCH_ORDER_SUCCESS = "FETCH_ORDER_SUCCESS"
export const FETCH_ORDER_FAILURE = "FETCH_ORDER_FAILURE"

export const FETCH_INSTRUCTOR_REQUEST = "FETCH_INSTRUCTOR_REQUEST";
export const FETCH_INSTRUCTOR_SUCCESS = "FETCH_INSTRUCTOR_SUCCESS";
export const FETCH_INSTRUCTOR_FAILURE = "FETCH_INSTRUCTOR_FAILURE";

export const FETCH_INSTRUCTOR_COURSES_REQUEST = "FETCH_INSTRUCTOR_COURSES_REQUEST";
export const FETCH_INSTRUCTOR_COURSES_SUCCESS = "FETCH_INSTRUCTOR_COURSES_SUCCESS";
export const FETCH_INSTRUCTOR_COURSES_FAILURE = "FETCH_INSTRUCTOR_COURSES_FAILURE";

export const FETCH_COURSE_CATEGORY_REQUEST = "FETCH_COURSE_CATEGORY_REQUEST";
export const FETCH_COURSE_CATEGORY_SUCCESS = "FETCH_COURSE_CATEGORY_SUCCESS";
export const FETCH_COURSE_CATEGORY_FAILURE = "FETCH_COURSE_CATEGORY_FAILURE";

export const FETCH_COURSE_TYPE_REQUEST = "FETCH_COURSE_TYPE_REQUEST";
export const FETCH_COURSE_TYPE_SUCCESS = "FETCH_COURSE_TYPE_SUCCESS";
export const FETCH_COURSE_TYPE_FAILURE = "FETCH_COURSE_TYPE_FAILURE";

export const UPLOAD_COURSE = "UPLOAD_COURSE";
export const UPLOAD_COURSE_SUCCESS = "UPLOAD_COURSE_SUCCESS";
export const UPLOAD_COURSE_FAILURE = "UPLOAD_COURSE_FAILURE";
export const POST_BLOG_SUCCESS = 'POST_BLOG_SUCCESS'
export const POST_BLOG_FAILED = 'POST_BLOG_FAILED'
